@if (headerType$ | async; as headerType) {
    @if (headerType === 'main') {
        <main-header></main-header>
        <attribution-bar></attribution-bar>
    } @else {
        <custom-header [titleTag]="headerType" [customStyle]="customStyle"></custom-header>
    }
}
